
        var result = require("!!../../../../node_modules/css-loader/index.js!./course-view.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/course-view/course-view.component.css
// module id = 584
// module chunks = 0